import { useMemo, useState } from "react";

export interface SortState {
    col: string;
    asc: boolean;
}

export function useSort<T>(items: T[], getValue: (item: T, col: string) => string | number, initialCol: string, initialAsc = true) {
    const [state, setState] = useState<SortState>({ col: initialCol, asc: initialAsc });

    const sorted = useMemo(() => {
        const copy = [...items];
        copy.sort((a, b) => {
            const va = getValue(a, state.col);
            const vb = getValue(b, state.col);
            const cmp = va < vb ? -1 : va > vb ? 1 : 0;
            return state.asc ? cmp : -cmp;
        });
        return copy;
    }, [items, state, getValue]);

    const toggle = (col: string) => setState((s) => (s.col === col ? { col, asc: !s.asc } : { col, asc: true }));
    const arrow = (col: string) => (state.col === col ? (state.asc ? "▲" : "▼") : "");

    return { sorted, toggle, arrow, sort: state };
}
